import { StoreonModule } from 'storeon'
import { useStoreon } from 'storeon/react'
import Utils from 'Utils'

import Shared from 'Services/Shared'

const KEY = 'session'

type StateValues = {
  accessToken?: string
  refreshToken?: string
}

type State = {
  [KEY]: StateValues
}

type Events = {
  'session/set': StateValues
  'session/clear': void
}

const INITIAL_STATE: StateValues = {
  accessToken: undefined,
  refreshToken: undefined,
}

const sessionModule: StoreonModule<State, Events> = store => {
  store.on('@init', () => ({
    [KEY]: INITIAL_STATE,
  }))
  store.on('session/set', (state, payload) => {
    return {
      [KEY]: {
        ...state[KEY],
        ...payload,
      },
    }
  })
  store.on('session/clear', () => ({
    [KEY]: INITIAL_STATE,
  }))
}

function getState() {
  return Shared.getStore().get()[KEY]
}

function getAccessToken() {
  return getState().accessToken
}

function set(values?: StateValues) {
  const currentToken = getState().accessToken
  if (values?.accessToken === currentToken) return

  Shared.getStore().dispatch('session/set', values)

  Utils.ApolloClient.restartWsClient('main')
  Utils.ApolloClient.restartWsClient('chat')
}
const Session = {
  getAccessToken,
  set,
}

function useSession() {
  const { session } = useStoreon<State, Events>(KEY)

  return {
    isAuthorized: !!session.accessToken,
    accessToken: session.accessToken,
  }
}

export type { Events, State }
export { KEY, Session, sessionModule, useSession }
